const LOCAL_STORAGE_LOGGED_IN_USER_DATA = "currentUser";
const LOCAL_STORAGE_JWT_TOKEN = "jwtToken";
const API_RESPONSE_MESSAGE_KEY = "message";
const USER_LOGIN_METHOD = "loginMethod"
const LOCAL_STORAGE_ADVANCED_MODE_PREFIX = "advancedMode_";
const LOCAL_STORAGE_ADVANCED_MODE_PROMPT_DISMISSED = "advancedModePromptDismissed_";
const LOCAL_STORAGE_CLAUDE_SESSION_ID = "claude_session_id";
const LOCAL_STORAGE_CONTINUE_SESSION_PREFIX = "continueSession_";

export {
    LOCAL_STORAGE_LOGGED_IN_USER_DATA,
    LOCAL_STORAGE_JWT_TOKEN,
    API_RESPONSE_MESSAGE_KEY,
    USER_LOGIN_METHOD,
    LOCAL_STORAGE_ADVANCED_MODE_PREFIX,
    LOCAL_STORAGE_ADVANCED_MODE_PROMPT_DISMISSED,
    LOCAL_STORAGE_CLAUDE_SESSION_ID,
    LOCAL_STORAGE_CONTINUE_SESSION_PREFIX,
}
